export type StartSessionWizardStep = 'session_name' | 'initial_message' | 'permissions' | 'review'

export type HostStartSessionWizardStep =
  | 'project_select'
  | 'session_name'
  | 'initial_message'
  | 'permissions'
  | 'review'

export interface StartSessionFormState {
  readonly sessionName: string
  readonly initialMessage: string
  readonly dangerouslySkipPermissions: boolean
}

export const INITIAL_START_SESSION_FORM: StartSessionFormState = {
  sessionName: '',
  initialMessage: '',
  dangerouslySkipPermissions: false,
}
